import { toast } from "react-toastify";
import Scheduling, { SchedulingStatus } from "../../../api/scheduling";
import Clients from "../../../api/clients";
import ApiError from '../../../utils/api-error';

import {
    setStorageWithExpiry, 
    getStorageValueWithExpiry, 
    getStorageMetadata, 
    getLastCalledTimeKey,
    getCallMessagesKey
} from '../../../utils/cache';

export const scheduling = {
  state: {
    schedulings: [],
    reservationTypes: [],
    barcodeScheduling: null,
    clients: [],
    timeBlocks: [],
    loading: false,
    schedulingTableColumns: []
  },
  reducers: {
    setSchedulings(state, payload) {
      return {
        ...state,
        schedulings: payload,
      };
    },
    setClients(state, payload) {
      return {
        ...state,
        clients: payload,
      };
    },
    setBarcodeScheduling(state, payload) {
      return {
        ...state,
        barcodeScheduling: payload,
      };
    },
    setTimeBlocks(state, payload) {
      return {
        ...state,
        timeBlocks: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    setReservationTypes(state, payload) {
      return {
        ...state,
        reservationTypes: payload,
      };
    },
    setSchedulingTableColumns(state, payload) {
      return {
        ...state,
        schedulingTableColumns: payload,
      }
    },
    setNewColumnToTableColumns(state, payload) {
      return {
        ...state,
        schedulingTableColumns: [...state.schedulingTableColumns, payload],
      }
    },
    clearStore() {
      return {};
    },
    setUpdateDriverPrimaryPhone(state, payload) {
      return {
          ...state,
          schedulingData: {
            ...state.schedulingData,
            driver_phone_number: payload.body.phone_number
          }
      }
    },
    setUpdateDriverSecondaryPhone(state, payload) {
      return {
          ...state,
          schedulingData: {
            ...state.schedulingData,
            driver_additional_phone_number: payload.body.phone_number
          }
      }
    },
    setAdditionalInfoCalled(state, payload) {
      return {
        ...state,
        schedulingData: {
          ...state.schedulingData,
          driver_phone_number: !! (payload?.driver_phone_number) ? `+55${payload.driver_phone_number}`.replace('(', '').replace(')', '').replace('-', '') : null,
          driver_additional_phone_number: !!(payload?.driver_additional_phone_number) ? `+55${payload.driver_additional_phone_number}`.replace('(', '').replace(')', '').replace('-', '') : null
        }
      }
    },
    setCallAgainStatus(state, payload) {
      return {
        ...state,
        schedulingData: {
          ...state.schedulingData,
          id_scheduling_status: payload
        }
      }
    },
    setCallMessages(state, payload) {
      return {
          ...state,
          schedulingData: {
            ...state.schedulingData,
            schedulingMessages: payload.map((item, index) => {
              
              switch(item.type) {

                case 'chat':
                  if (!!item.is_send) {
                    const chatMessage =  `${decodeURIComponent(item.body.replace(/\*([^*]+)\*/g, '$1'))}`;
                    return {
                      id: index,
                      receiver: ` ${state.schedulingData?.driver_name}`,
                      body: chatMessage,
                      type: item.type,
                      time: `${item.created_at}`,
                      statusWhatsApp1: (item.is_send === true)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 1) && (subItem.channel === 'whatsapp')) {
                          switch(subItem.status) {
                            case 'submitted':
                              return `sent`
                            case 'delivered':
                              return `received`
                            case 'read':
                              return `read`
                            default:
                              return `error`
                          }
                        } else {
                          return ''
                        }
                      }).filter(x => !!x)[0]
                      : `not_sent`,
                      showSim1Icon: (item.is_send === true)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 1)) {
                          return true
                        } else {
                          return false
                        }
                      }).filter(x => !!x)[0]
                      : false,
                      statusWhatsApp2: (item.is_send === true)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 2) && (subItem.channel === 'whatsapp')) {
                          switch(subItem.status) {
                            case 'submitted':
                              return `sent`
                            case 'delivered':
                              return `received`
                            case 'read':
                              return `read`
                            default:
                              return `error`
                          }
                        } else {
                          return ''
                        }
                      }).filter(x => !!x)[0]
                      : `not_sent`,
                      showSim2Icon: (item.is_send === true)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 2)) {
                          return true
                        } else {
                          return false
                        }
                      }).filter(x => !!x)[0]
                      : false,
                    }
                  } else {

                    return {
                      id: index,
                      sender: ` ${state.schedulingData?.driver_name}`,
                      body: `${item.body}`,
                      type: item.type,
                      time: `${item.created_at}`,
                      statusWhatsApp1: (item.is_send === false)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 1)) {
                          switch(subItem.status) {
                            case 'submitted':
                              return `sent`
                            case 'delivered':
                              return `received`
                            case 'read':
                              return `read`
                            default:
                              return `error`
                          }
                        } else {
                          return ''
                        }
                      }).filter(x => !!x)[0]
                      : `not_sent`,
                      showSim1Icon: (item.is_send === false)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 1)) {
                          return true
                        } else {
                          return false
                        }
                      }).filter(x => !!x)[0]
                      : false,
                      statusWhatsApp2: (item.is_send === false)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 2)) {
                          switch(subItem.status) {
                            case 'submitted':
                              return `sent`
                            case 'delivered':
                              return `received`
                            case 'read':
                              return `read`
                            default:
                              return `error`
                          }
                        } else {
                          return ''
                        }
                      }).filter(x => !!x)[0]
                      : `not_sent`,
                      showSim2Icon: (item.is_send === false)
                      ? item.header.map((subItem) => {
                        if((subItem.sim_order === 2)) {
                          return true
                        } else {
                          return false
                        }
                      }).filter(x => !!x)[0]
                      : false,
                    }

                  }

                case 'warning_update_phone':
                  const {sim_order, old, new: newphone} = item?.body;
                  const created_time = new Date(item.created_at).toLocaleTimeString('en-US',
                  {
                    hour12: false,
                    hour: "numeric",
                    minute: "numeric"
                  });
                  let template = '';

                  if (!!old && !!newphone){
                    template = `alterado de ${old} para ${newphone}`;
                  }else if(!old && !!newphone){
                    template = `adicionado (${newphone})`;
                  }else if (!!old && !newphone){
                    template = `removido (${old})`;
                  }

                  const messageStr = !!template ? `Número de telefone ${sim_order} ${template} - ${created_time}`: '';

                  return {
                    id: index,
                    type: item.type,
                    body: messageStr
                  };

                case 'warning_call_timeout':

                  return {
                    id: index,
                    receiver: "Motorista",
                    body: "Chamado expirado.",
                    time: `${item.created_at}`,
                    type: item.type
                  }

                default:

                  return {
                    id: index,
                    receiver: "Motorista",
                    body: "Algo deu errado.",
                    time: `${item.created_at}`,
                    type: 'error'
                  }
              }
            })
          }
      }
    },
    
    setCallMessagesMetadata(state, payload) {
      return {
          ...state,
          schedulingData: {
            ...state.schedulingData,
            metadata: {...state.schedulingData.metadata,  ...payload}
          }
      }
    },

    setLastCalledTime(state, payload) {
      return {
          ...state,
          schedulingData: {
            ...state.schedulingData,
            metadata: {
               ...state.schedulingData.metadata, lastCalledTime: payload
            }
          }
      }
    },
    
    setDriverResponse(state) {
      return {
          ...state
      }
    },
    setUpdateStatusMessage(state) {
      return {
          ...state
      }
    },
    setStatus(state, payload) {
      return {
        ...state,
        schedulingData: {
          ...state.schedulingData, ...payload
        }
      }

    }
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        let data = [];
        if (payload) {
          const res = await Scheduling.listWithFilter(payload);
          data = res.data;
        }
        this.setSchedulings(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async getReservationTypesAsync(payload) {
      try {
        const { data } = await Scheduling.getReservationTypes();
        this.setReservationTypes(data);
        return data;
      } catch {
        return [];
      }
    },
    async addAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.add(payload);
        this.loadAsync({
          branchId: data.id_branch,
          date: data.start_date.substring(0, 10),
        });
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return {
          success: false,
          message: error.response.data || "Erro ao adicionar turno.",
        };
      }
      return { success: true, message: "Turno adicionado com sucesso." };
    },
    async updateAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          scheduling: { schedulings },
        } = rootState;
        await Scheduling.update(payload);
        for (const scheduling of schedulings) {
          if (payload.id === scheduling.id) {
            scheduling.driver_name = payload.driver_name;
            scheduling.truck_plate = payload.truck_plate;
            scheduling.driver_document = payload.driver_document;
            break;
          }
        }
        this.setSchedulings(schedulings);
        this.loading({ loading: false });
        return { success: true, message: "Agendamento alterado com sucesso." };
      } catch (error) {
        this.loading({ loading: false });
        toast.error(error.response.data || "Ops :( Algo deu errado!");
      }
    },
    async getStatus(payload) {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.getStatus(payload);
        this.setStatus(data);
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return null;
      }
    },
    async get(payload) {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.get(payload);
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message: error.response.data || "Erro ao consultar agendamento.",
        };
      }
    },
    async findByBarcode(payload) {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.findByBarcode(payload);
        this.setBarcodeScheduling(data);
        this.loading({ loading: false });
      } catch(error) {
        this.setBarcodeScheduling(null);
        this.loading({ loading: false });
        throw new ApiError(error.response.status, error.response.data);
      }
    },
    async checkinDriver(payload, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        const { data } = await Scheduling.checkinDriver(payload);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].driver_checkin_date =
            data.driver_checkin_date;
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
          schedulings[schedulingIndex].scheduling_status = SchedulingStatus.inLine;
          this.setSchedulings(schedulings);
        }
        return data;
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao realizar checkin do motorista.",
        };

      }
    },
    async start(payload, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        const { data } = await Scheduling.start(payload);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].started_date = data.started_date;
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
          schedulings[schedulingIndex].called_at = data.called_at;
          this.setSchedulings(schedulings);
        }
        return data;
      } catch (error) {
        console.error(error);
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao iniciar o atendimento.",
        };
      }
    },
    async finish(payload, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        this.loading({ loading: true });
        const { data } = await Scheduling.finish(payload);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].ended_date = data.ended_date;
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
          schedulings[schedulingIndex].scheduling_status = SchedulingStatus.completed;
          this.setSchedulings(schedulings);
        }
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao finalizar o agendamento.",
        };
      }
    },
    async cancel({ id, reason }, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        this.loading({ loading: true });
        const { data } = await Scheduling.cancel(id, reason);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].rds_id = data.rds_id;
          schedulings[schedulingIndex].cancelled_reason = data.cancelled_reason;
          schedulings[schedulingIndex].scheduling_status = SchedulingStatus.canceled;
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
          this.setSchedulings(schedulings);
        }
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao cancelar o agendamento.",
        };
      }
    },
    async setRDSNumber(payload, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        this.loading({ loading: true });
        const { id, RDSNumber } = payload;
        const { data } = await Scheduling.setRDSNumber(id, RDSNumber);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].ended_date = data.ended_date;
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
          this.setSchedulings(schedulings);
        }
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message: error.response.data || "Erro ao atualizar turno.",
        };
      }
    },
    async deleteAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          scheduling: { schedulings },
        } = rootState;
        await Scheduling.delete(payload.id);
        this.setSchedulings(schedulings.filter((p) => p.id !== payload.id));
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async cancelAsync({ id, reason }, rootState) {
      try {
        this.loading({ loading: true });
        const {
          scheduling: { schedulings },
        } = rootState;
        await Scheduling.cancel(id, reason);
        for (const scheduling of schedulings) {
          if (id === scheduling.id) {
            scheduling.scheduling_status = SchedulingStatus.canceled;
            break;
          }
        }
        this.setSchedulings(schedulings);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadClientsAsync() {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.listClients();
        this.setClients(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadTimeBlocksAsync(payload) {
      try {
        this.loading({ loading: true });
        const { data } = await Scheduling.listTimeBlocks(payload);
        this.setTimeBlocks(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async getClientByDocumentAsync(payload) {
      try {
        const { data } = await Clients.getByDocument(payload);
        return data;
      } catch (error) {
        return null;
      }
    },

    async calledsAsync(payload) {
      try {
        this.loading({ loading: true });
        await Scheduling.calleds({ ...payload, branch: payload?.branch?.value });
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao chamar agendamentos.",
        };
      }
    },

    async calledAsync(id, rootState) {
      const now = new Date().getTime();
      this.setLastCalledTime(now);
      localStorage.setItem(getLastCalledTimeKey(id), now);

      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        this.loading({ loading: true });
        const { data } = await Scheduling.called(id);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
      
        if (data && schedulingIndex !== -1) {
          schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
            schedulings[schedulingIndex].scheduling_status =
            data.scheduling_status;
          schedulings[schedulingIndex].called_at = data.called_at;
          this.setSchedulings(schedulings);
        }
        
        localStorage.removeItem(getCallMessagesKey(id));
        this.getCallMessages(id);

        this.loading({ loading: false });
        this.setCallAgainStatus(7);
        return data;
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
        this.setLastCalledTime(null);
        localStorage.removeItem(getLastCalledTimeKey(id));
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao chamar o agendamento.",
        };
      }
    },

    async inTransitAsync(id, rootState) {
      try {
        const {
          scheduling: { schedulings },
        } = rootState;
        this.loading({ loading: true });
        const { data } = await Scheduling.inTransit(id);
        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
            schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
            schedulings[schedulingIndex].scheduling_status =
            data.scheduling_status;
          this.setSchedulings(schedulings);
        }
        this.loading({ loading: false });
        return data;
      } catch (error) {
        this.loading({ loading: false });
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao cancelar o agendamento.",
        };
      }
    },

    async saveAdditionalInfoCalled(payload, rootState) {
      try {

        const {
          scheduling: { schedulings },
        } = rootState;

        this.loading({ loading: true });
        const { data } = await Scheduling.saveAdditionalInfoCalled(payload);

        const schedulingIndex = schedulings.findIndex(
          (scheduling) => scheduling.id === data.id
        );
        if (data && schedulingIndex !== -1) {
            schedulings[schedulingIndex].id_scheduling_status =
            data.id_scheduling_status;
            schedulings[schedulingIndex].scheduling_status =
            data.scheduling_status;
          this.setSchedulings(schedulings);
        }
        this.setAdditionalInfoCalled(payload);
        this.loading({ loading: false });
        return data;

      } catch (error) {
        this.loading({ loading: false });
        toast.error("Erro! Verifique os números de telefone.");
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Ops :( Algo deu errado !",
        };
      }
    },
    async updateDriverPrimaryPhone(payload) {
      try {
        this.loading({ loading: true });
        await Scheduling.updateDriverPrimaryPhone(payload);
        this.setUpdateDriverPrimaryPhone(payload)
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Erro! Verifique o número do telefone.");
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao salvar telefone.",
        };
      }
    },
    async updateDriverSecondaryPhone(payload) {
      try {
        this.loading({ loading: true });
        await Scheduling.updateDriverSecondaryPhone(payload);
        this.setUpdateDriverSecondaryPhone(payload)
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Erro! Verifique o número do telefone.");
        return {
          data: null,
          success: false,
          message:
            error.response && error.response.data
              ? error.response.data
              : "Erro ao salvar telefone.",
        };
      }
    },
    async getCallMessages(id) {
      
      const lastCalledTime = localStorage.getItem(getLastCalledTimeKey(id));
            
      try {
        this.loading({ loading: true });
        const storageKey = getCallMessagesKey(id);
       
        const cachedResponse = getStorageValueWithExpiry(storageKey) ?? null;
        
        if (cachedResponse == null){
          
          const res = await Scheduling.getCallMessages(id);
          
          const { data } = res || {};
         
          const { metadata, messages } = data || {};
         
          const { calledTimeout, backendSyncTimeout } = metadata || {};
          
          setStorageWithExpiry(storageKey, messages, backendSyncTimeout * 1000, {
            backendSyncTimeout,
            calledTimeout
          });
        
          this.setCallMessages(messages);

          const { createdAt: lastBackendSyncTime } = getStorageMetadata(storageKey);
          this.setCallMessagesMetadata({
            lastCalledTime,
            calledTimeout,
            lastBackendSyncTime,
            backendSyncTimeout
          });

        }else{
                    
          this.setCallMessages(cachedResponse);

          const { createdAt: lastBackendSyncTime, calledTimeout, backendSyncTimeout } = getStorageMetadata(storageKey) || {};
         
          this.setCallMessagesMetadata({
            lastCalledTime,
            calledTimeout,
            lastBackendSyncTime,
            backendSyncTimeout
          });
          
        }
        this.loading({ loading: false });
      } catch (error) {
       
        this.loading({ loading: false });
        return null
      }
    },
    async driverResponse(payload) {
      try {
        this.loading({ loading: true });
        const res = await Scheduling.driverResponse(payload);
        this.setDriverResponse(res)
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return null
      }
    },
    async updateStatusMessage(payload) {
      try {
        this.loading({ loading: true });
        const res = await Scheduling.updateStatusMessage(payload);
        this.setUpdateStatusMessage(res)
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return null
      }
    },
    addSchedulingTableColumns(payload) {
      this.setSchedulingTableColumns(payload);
    },
    concatToSchedulingTableColumns(payload, rootState) {
      const { schedulingTableColumns } = rootState.scheduling;
      if (!schedulingTableColumns.find((p) => p.key === payload.key)) {
        return this.setNewColumnToTableColumns(payload);
      }
      return;
    },
    /**
     *
     * @param {object} payload
     * @param {string} payload.name
     * @param {string} payload.tableSelector
     * @param {boolean} payload.isVisible
     * @param {*} rootState
     */
    changeSchedulingTableColumnVisibility(payload, rootState) {
      const { schedulingTableColumns } = rootState.scheduling;
      const newSchedulingTableColumns = schedulingTableColumns.map((column, index) => {
        payload.forEach((el) => {
          if (el.tableSelector === column.selector) {
            column.omit = !el.isVisible
          }
        });
        return { ...column };
      });
      this.setSchedulingTableColumns(newSchedulingTableColumns);
    },
  }),
};
